import script from "./SortIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SortIcon.vue?vue&type=script&setup=true&lang=js"

import "./SortIcon.vue?vue&type=style&index=0&id=70f43d7c&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70f43d7c"]])

export default __exports__